module.exports = __webpack_public_path__ + "static/Kazu-eff5b5a70c2ae632e3edb5339b974119.jpg";